import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Container, Text } from '../primitives';
import { tokens } from '../../config/themeTokens';

const FooterEl = styled.footer`
  background-color: ${tokens.colors.backgroundAlt};
  border-top: 1px solid ${tokens.colors.border};
  padding: ${tokens.spacing.xl} 0;
  margin-top: auto;
`;

const FooterNav = styled.nav`
  display: flex;
  gap: ${tokens.spacing.lg};
  margin-bottom: ${tokens.spacing.md};
`;

const FooterLink = styled(Link)`
  font-size: ${tokens.typography.sizeSm};
  color: ${tokens.colors.textMuted};
  text-decoration: none;

  &:hover {
    color: ${tokens.colors.primary};
  }
`;

export function SiteFooter() {
  const base = '/twentytwentysix';

  return (
    <FooterEl>
      <Container>
        <FooterNav>
          <FooterLink to={`${base}/`}>Home</FooterLink>
          <FooterLink to={`${base}/resources`}>Resources</FooterLink>
          <FooterLink to={`${base}/podcasts`}>Podcasts</FooterLink>
          <FooterLink to={`${base}/events`}>Events</FooterLink>
          <FooterLink to={`${base}/membership`}>Membership</FooterLink>
          <FooterLink to={`${base}/contact`}>Contact</FooterLink>
          <FooterLink to={`${base}/about`}>About</FooterLink>
          <FooterLink to={`${base}/collective`}>Collective</FooterLink>
          <FooterLink to={`${base}/login`}>Login</FooterLink>
        </FooterNav>
        <Text as="p" $muted style={{ margin: 0, fontSize: tokens.typography.sizeXs }}>
          TwentyTwentysix redesign preview — not yet live.
        </Text>
      </Container>
    </FooterEl>
  );
}

export default SiteFooter;
